module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.a2953670.woff2";